import React from 'react';
import styled from 'styled-components';

const H1 = styled.h1`
  margin: 0;
  padding: 1em;
  font-family: ${p => p.theme.sansSerif};
  text-align: center;
`;

export default ({ position }) => <H1>{position}</H1>;
